import React from "react";

import { cn } from "../lib/cn";

interface PaginationProps {
  children: React.ReactNode;
}

interface PaginationItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

const PaginationRoot = ({ children }: PaginationProps) => (
  <nav aria-label="페이지 이동">
    <div className="pagination">{children}</div>
  </nav>
);

const PaginationItem = ({ active, className, children, ...props }: PaginationItemProps) => (
  <button
    type="button"
    className={cn("pagination-item", active && "active", className)}
    aria-current={active ? "page" : undefined}
    {...props}
  >
    {children}
  </button>
);

type PaginationComponent = typeof PaginationRoot & { Item: typeof PaginationItem };

const Pagination = PaginationRoot as PaginationComponent;
Pagination.Item = PaginationItem;

export default Pagination;
